<script lang="ts" setup>
import { ref } from "vue";

const props = defineProps({
    url: {
        type: String,
        required: true,
    },
});

const youtubeLoaded = ref<boolean>(false);

function getVideoId(url) {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[7].length === 11 ? match[7] : false;
}

const videoId = getVideoId(props.url);

async function loadFrame() {
    youtubeLoaded.value = true;
}
</script>

<template>
    <div
        class="aspect-video bg-black bg-cover"
        :style="`background-image: url('https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg')`"
    >
        <!-- Show a preview while the video loads-->
        <button
            v-show="!youtubeLoaded"
            class="relative block h-full w-full transition-opacity"
            aria-label="Click to play YouTube Video"
            @click="loadFrame"
        >
            <!--<img :src="getYoutubeThumbnailImage()" :alt="title || 'YouTube Video Thumbnail'" class="" />-->

            <svg
                height="100%"
                version="1.1"
                viewBox="0 0 68 48"
                width="100%"
                class="absolute top-[calc(50%-24px)] left-[calc(50%-34px)] h-[48px] w-[68px]"
            >
                <path
                    d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"
                    fill="#f00"
                ></path>

                <path d="M 45,24 27,14 27,34" fill="#fff"></path>
            </svg>
        </button>

        <div v-show="youtubeLoaded" class="h-full">
            <iframe
                loading="lazy"
                width="100%"
                height="100%"
                :src="`https://www.youtube.com/embed/${videoId}?autoplay=1&amp;playsinline=1`"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
            ></iframe>
        </div>
    </div>
</template>
